/* @flow */
import { commitMutation } from 'react-relay';

import RelayStore from './RelayStore';

export default (mutation: string) =>
  function createMutation<Input, Output>(variables: Input): Promise<Output> {
    return new Promise((resolve, reject) => {
      commitMutation(RelayStore.store, {
        mutation,
        variables,
        onCompleted: response => resolve(response),
        onError: err => {
          if (err.source) {
            return reject(
              new Error(err.source.errors.map(e => e.message).join(', '))
            );
          }

          return reject(err);
        },
      });
    });
  };



// WEBPACK FOOTER //
// ./src/relay/createMutation.js